import "core-js/modules/es6.number.constructor";
import Vue from "vue";
import sourcePreview from "components/SourcePreview.vue";
import { GetSourceInfo, GetPartnerSource, AddCourseScourse } from "api/v1.design.courseware";
import { GetSchoolIdList, GetPartnerCourseType } from "api/v1.partner.source";
import { Message } from "element-ui";
import PreparingCourseware from "components/PreparingCourseware.vue";
export default Vue.extend({
  name: "ToPartnerSource",
  components: {
    "source-preview": sourcePreview,
    PreparingCourseware: PreparingCourseware
  },
  data: function data() {
    return {
      files: [],
      label: "课件",
      pageSize: 8,
      pageIndex: 1,
      totalCount: 0,
      name: "source",
      list: [],
      nodePathList: [],
      tabPosition: "top",
      isShow_source: true,
      courseName: "22",
      newFolderId: "",
      dataCount: 1,
      sourceIds: [],
      sourceId: "",
      checks: [],
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      disabled: false,
      checkStatus: false,
      checkArr: [],
      dialogVisiblePreviewResources: false,
      activeName: "source",
      folderId: "",
      SchoolCourseId: "",
      IsSchoolCourseType: false,
      keyIndex: 0,
      SchoolCourseTypeList: [],
      CreatedSchoolId: "",
      schoolList: [],
      IsSource: false,
      defaultCover: require("assets/images/noCover.jpg") // 默认封面

    };
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    activityIds: {},
    importfolderId: {
      type: String,
      default: "0"
    },
    IsState: {
      type: Number,
      default: 0
    },
    setData: {
      type: Object,
      default: []
    }
  },
  created: function created() {
    console.log("activityIds=" + this.activityIds);
    this.getSchoolIdList();
  },
  watch: {
    sourceIds: function sourceIds() {
      this.$emit("update:setData", this.sourceIds);
    },
    checkData: function checkData(val) {
      var checkLength = this.list.length;

      for (var i = 0; i < checkLength; i++) {
        if (this.list[i].checked) {
          if (this.list[i].checked == true) {
            this.list[i].chec1ked = false;
          }
        }
      }
    }
  },
  methods: {
    getSchoolIdList: function getSchoolIdList() {
      var _this = this;

      GetSchoolIdList().then(function (rst) {
        _this.CreatedSchoolId = rst.SchoolList[0].CreatedSchoolId;

        _this.$emit('update:CreatedSchoolId', _this.CreatedSchoolId);

        _this.schoolList = rst.SchoolList;

        if (_this.schoolList.length > 0) {
          _this.getPartnerCourseType(_this.schoolList[0].CreatedSchoolId, 0);
        }
      });
    },
    cance: function cance() {
      this.list = [];
      this.totalCount = 0;
      this.pageSize = 0;
      this.courseName = "";
      this.nodePathList = [];
      this.dataCount = 0;
    },
    onAllChangeHandler: function onAllChangeHandler() {
      this.IsSource = true;
      this.folderId = "0";
      this.SchoolCourseId = "";
      this.getPartnerSource(1);
      this.cance();
      this.IsSchoolCourseType = false;
    },
    getPartnerCourseType: function getPartnerCourseType(SchoolId, index) {
      var _this2 = this;

      this.IsSource = false;
      this.CreatedSchoolId = SchoolId;
      this.IsSchoolCourseType = true;
      this.keyIndex = index;
      GetPartnerCourseType(SchoolId).then(function (rst) {
        _this2.SchoolCourseTypeList = rst.list;
      });
    },
    GetSchool: function GetSchool(event, index) {
      this.IsSource = true;
      this.folderId = "0";
      this.SchoolCourseId = event; // this.CreatedSchoolId=event;

      this.getPartnerSource(1);
      this.cance();
      this.IsSchoolCourseType = false;
    },
    ///关闭弹窗
    dialogClose: function dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    ///获取合作伙伴资源
    getPartnerSource: function getPartnerSource(page) {
      var _this3 = this;

      this.$nextTick(function () {
        GetPartnerSource(_this3.CreatedSchoolId, _this3.folderId, page, _this3.SchoolCourseId).then(function (rst) {
          _this3.list = rst.list;
          _this3.totalCount = rst.pagination.totalCount;
          _this3.pageSize = rst.pagination.pageSize;
          _this3.courseName = rst.courseName;
          _this3.nodePathList = rst.nodePathList;
          _this3.dataCount = rst.dataCount;
          console.log(_this3.list);
        });
      });
    },
    ///打开文件夹
    clickFolderHander: function clickFolderHander(newFolderId) {
      this.folderId = newFolderId;
      var pageIndex = this.list.pageIndex;
      this.getPartnerSource(pageIndex);
    },
    ///预览课件
    previewImage: function previewImage(Id, url, type) {
      var _this4 = this;

      if (type == ".zip" || type == ".rar" || type == "7z") {
        this.$message("压缩包不支持预览");
      } else {
        if (type != "") {
          this.sourceId = Id;
          this.dialogVisiblePreviewResources = true;
        }

        GetSourceInfo(Id).then(function (rst) {
          console.log(rst);

          if (rst.status == -1) {
            Message.warning("文件转换失败不能预览");
          } else if (rst.status == -2) {
            Message.warning("文件正在转换请稍后预览");
          } else if (rst.status == 1) {
            _this4.sourceUrl = {
              id: Id,
              url: rst.docPriviewUrl,
              type: type,
              docName: rst.docName,
              docType: rst.docType
            };
          }
        });
      }
    },
    ///分页
    onPageChangeHandler: function onPageChangeHandler(page) {
      this.getPartnerSource(page);
    },
    ///选择资源
    handleSelectionChange: function handleSelectionChange(source) {
      var idx = this.sourceIds.indexOf(source.Id);
      var checked = source.checked;

      if (idx >= 0 && !checked) {
        this.sourceIds.splice(idx, 1);
      } else if (idx < 0 && checked) {
        this.sourceIds.push(source.Id);
      }
    },
    ///导入课件
    importSource: function importSource() {
      var _this5 = this;

      debugger;
      console.log(this.CreatedSchoolId + "asedasdadasdasdas");

      if (this.sourceIds.length == 0) {
        this.$message.warning("请选择课件！");
      } else {
        AddCourseScourse(this.sourceIds, this.courseId, this.importfolderId, this.CreatedSchoolId).then(function (rst) {
          if (rst.code > 0) {
            _this5.$emit("update:IsState", Math.random());

            _this5.$message.success(rst.msg);
          } else {
            _this5.$message({
              type: "warning",
              message: rst.msg
            });
          }

          var checkLength = _this5.list.length;

          for (var i = 0; i < checkLength; i++) {
            if (_this5.list[i].checked) {
              if (_this5.list[i].checked == true) {
                _this5.list[i].checked = false;
              }
            }
          }

          _this5.sourceIds = [];

          _this5.$emit("closeDialog", true);
        });
      }

      this.disabled = false;
      this.checkStatus = true;
    }
  }
});